import React, { useCallback } from 'react';
import { SourceStoneKey } from '../../../types';

interface SourceItemProps {
  stone: SourceStoneKey;
  text: string;
  toggleMetastone: (stone: SourceStoneKey) => void;
}

const SourceItem = React.memo(({ 
  stone, 
  text, 
  toggleMetastone 
}: SourceItemProps) => {
  const handleClick = useCallback(() => toggleMetastone(stone), [toggleMetastone, stone]);

  return (
    <>
      <div
        id={`source-${stone.toLowerCase()}`}
        onClick={handleClick}
      >
      </div>
      <div id={`source-${stone.toLowerCase()}-text`} className="side-panel-text">
        {text}
      </div>
    </>
  );
});

export default SourceItem;
